import React, {useCallback, useMemo, useState} from "react";
import FlashImg from "../../assets/photobooth/shine effect.png"
import Frame1Bg from "../../assets/photobooth/frame-1-bg.png";
import ButtonBack from "../../assets/photobooth/button-back.png";
import ButtonNext from "../../assets/photobooth/button-next.png";
import 'fabric-webpack';
import TermsAndConditions from "./TermsAndConditionsDialog";
import DivideSparkImg from "./DivideSparkImg";
import FrameSelect from "./FrameSelect";
import StickerSelect from "./StickerSelect";
import SubmittedDialog from "./SubmittedDialog";
import SharePhotoDialog from "./SharePhotoDialog";
import DisplayIf from "../../components/common/DisplayIf";
import {
    domToImage,
    convertToFinalImage,
    downloadImage,
    submitSocialItem,
    unwrapAll
} from "../../helpers/photoboothHelpers";
import {ItemTypes} from "../../constants";
import {Typography} from "@material-ui/core";
import {printInfo} from "../../helpers/img/imageHelpers";

const CLICK_URL = "./static/audio/photobooth/shutter.mp3";

const fabric = window.fabric

Number.prototype.in = function (arr) {
    return arr.includes(this)
}
let audio = new Audio(CLICK_URL);

navigator.getUserMedia = (
    // navigator.mediaDevices.getUserMedia ||
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.msGetUserMedia
);

const createStyles = (width, height) => ({
    root: {
        marginTop: '5.1vw'
    },
    videoDiv: {
        width: width + 5,
        height: 'auto',
        paddingTop: '0.1vw'
    },
    photoRoot: {
        position: 'relative',
        paddingBottom: '4.1vw'
    },
    flesh: {
        width: '100%',
        zIndex: 1,
        position: 'absolute',
        top: 1 - height / 1.9 - 5,
        left: width / 2.1 + 2
    },
    selectedFrame: {
        width: '101%',
        height: 'auto',
        position: 'relative',
        zIndex: 10
    },
    boothVideo: {margin: "auto"},
    boothCanvas: {
        position: 'absolute',
        width: '100%',
        zIndex: 4,
        top: '1.5vw',
        left: 0,
        margin: 'auto',
    },
    boothCanvasImage: {
        position: 'absolute',
        zIndex: 4,
        top: 0,
        left: 0,
        margin: 'auto',
        display: 'none'
    },
    boothCanvasFinal: {
        position: 'absolute',
        zIndex: 4,
        top: 0,
        left: 0,
        margin: 'auto',
        display: 'none'
    },
    boothFinalStickerCanvas: {
        display: 'none'
    },
    stickerCanvasContainer: {
        position: 'absolute',
        zIndex: 30,
        top: 0,
        left: 0,
        margin: 'auto'
    },
    localImageDiv: {
        height: height,
        margin: 'auto',
        left: 0,
        top: 0,
        zIndex: 31
    },
    captionText: {
        color: 'white',
        margin: 'auto',
        fontFamily: 'DINPro-Regular',
        left: -6,
        marginLeft: 0,
        fontSize: '1.2vw'
    },
    navigationBtn: {
        left: '-6vw',
        bottom: 0,
        position: 'absolute',
        cursor: 'pointer',
        fontSize: '1.5vw',
        top: '50%'
    },
    nextNavBtn: {
        left: undefined,
        right: '-6vw'
    },
    navImg: {
        width: '4vw'
    },
    takePhotoDiv: {
        margin: '-6px auto',
        width: width
    },
    caption: {
        position: 'relative',
        top: '0vw',
        margin: ' 0 auto'
    }
})

function PhotoBoothPage() {
    const [width, setWidth] = React.useState(window.innerWidth * 0.2);
    const [height, setHeight] = React.useState(window.innerWidth * 0.155);

    React.useEffect(() => {
        function handleResize() {
            if (window.innerWidth > 900) {
                setWidth(window.innerWidth * 0.2)
                setHeight(window.innerWidth * 0.155)
            } else {
                setWidth(window.innerWidth * 0.15)
                setHeight(window.innerWidth * 0.155)
            }
        }

        window.addEventListener('resize', handleResize)
    })

    const [step, setStep] = React.useState(0);
    const [context, setContext] = React.useState(null);
    const [timerCount, setTimerCount] = React.useState(3);
    const [showTimer, setShowTimer] = React.useState(false);
    const [showBoothCanvas, setBoothCanvas] = React.useState(false);
    const [showFlash, setShowFlash] = React.useState(false);
    const [selectedFrame, setSelectedFrame] = React.useState(Frame1Bg);
    const [finalImageURL, setFinalImageURL] = React.useState("");
    const [captionText, setCaptionText] = React.useState('');
    const [showStickerContainer, setShowStickerContainer] = React.useState(false);
    const [cameraLoading, setCameraLoading] = React.useState(true)
    const [takePhotoPressed, setTakePhotoPressed] = React.useState(false)

    const [allowed, setAllowed] = useState(true)

        let localVideo = null;

    const startPhotoBooth = () => {
        setStep(1);
        navigator.mediaDevices
            .getUserMedia({video: {facingMode: 'user'}, audio: false})
            .then(stream => {
                setCameraLoading(false)
                let canvas = document.getElementById("booth_canvas");
                let contxt = canvas.getContext("2d");
                contxt.clearRect(0, 0, width, width);
                console.log('TH', stream)
                console.log(canvas)
                console.log(contxt)
                setContext(contxt);
                localVideo = document.getElementById("booth_video");
                if (localVideo) {
                    localVideo.srcObject = stream;
                    localVideo.onloadedmetadata = function (e) {
                        localVideo.play();
                        setWidth(width);
                        setHeight(width)
                    };
                    localVideo.onpause = function (e) {
                        stream.getTracks().forEach(track => {
                            track.stop();
                        });
                    };
                }
            })
            .catch(error => {
                console.warn(error.message);
                setAllowed(false)
            })
    };


    const snapPhoto = () => {
        console.log('snap')
        setTakePhotoPressed(true)
        let photo_booth_timer = 3;
        setTimerCount(photo_booth_timer);
        setShowTimer(true);
        // start Timer
        let photobooth_countdownInterval = setInterval(function () {
            if (photo_booth_timer === 2) {
                setShowFlash(true);
            } else if (photo_booth_timer === 1) {
                clearInterval(photobooth_countdownInterval);
                setShowTimer(false);
                setShowFlash(false);
                localVideo = document.getElementById("booth_video");
                // Take Photo
                if (localVideo) {
                    // click photo audio

                    audio.play().catch(err => console.warn('audio didnt play', err));
                    setStep(2);

                    let canvasServer = document.getElementById("booth_canvas_image");
                    const canvasServer_context = canvasServer.getContext("2d");
                    canvasServer_context.drawImage(localVideo, 0, 0, 1620, 1620 * 0.8);

                    console.log('lv', localVideo)
                    localVideo.pause();
                    let frameImage = document.getElementById('frame-1')
                    context.drawImage(localVideo, 0, 0, frameImage.offsetHeight, frameImage.offsetHeight * 0.8);

                    for (const track of localVideo.srcObject.getTracks()) {
                        track.stop();
                    }
                    localVideo.src = "";
                    localVideo.srcObject = null;
                }
                setBoothCanvas(true);
                setTakePhotoPressed(false)
                init_sticker_canvas();
                return;
            }
            setTimerCount(--photo_booth_timer);
        }, 1000);
    };


    const init_sticker_canvas = () => {
        unwrapAll(width, height)
        window.CANVAS = new fabric.Canvas('sticker_canvas', {allowTouchScrolling: false});
    }

    const onClickSticker = (url) => {
        fabric.Image.fromURL(url, img => {
            img.scale(0.5);
            img.left = 100;
            img.top = height / 2;
            img.cornerSize = 10;
            img.borderColor = "rgba(237,31,36,0.75)";
            img.cornerColor = "rgba(237,31,36,0.5)";
            img.transparentCorners = false;

            window.CANVAS.add(img);
            window.CANVAS.setActiveObject(img);
        });
    };


    const handlePrevNextStep = (stepType) => {
        let privateStep = step;
        if (step === 4 && stepType === 'next') {
            printInfo('BEFORE LastConversion', finalImageURL)
            domToImage(finalImageURL).then(url => {
                setStep(5)
                printInfo('AFTER LastConversion', url)
                setFinalImageURL(url)
                return submitSocialItem(url, ItemTypes.PHOTO)
            });
        } else if (step === 3 && stepType === 'next')
            convertToFinalImage(selectedFrame)
                .then(setFinalImageURL)
                .then(() => setStep(4))
        else if (step === 3 && stepType === 'prev') {
            setShowStickerContainer(false);
            setStep(2)
        } else if (step === 2 && stepType === 'prev') {
            setBoothCanvas(false)
            setShowStickerContainer(false);
            startPhotoBooth();
            setStep(1)
        } else if (step === 2 && stepType === 'next') {
            setStep(3)
            setShowStickerContainer(true);
        } else setStep(stepType === 'next' ? ++privateStep : --privateStep);
    }

    const prevStep = () => handlePrevNextStep('prev')
    const nextStep = () => handlePrevNextStep('next')

    const resetStep = () => {
        // reset all other things here
        setSelectedFrame(Frame1Bg);
        setStep(0);
    };

    const handleCaptionTextChange = (e) => {
        if (e.target.value)
            setCaptionText(e.target.value)
    }

    const handleClose = useCallback(() => {
        resetStep(0)
    }, []);

    /*
        booth_canvas - holds image for 2-nd and 3-d step
        booth_canvas_image - holds a photo from the capture. and is used to paste photo to final image
    */

    const styles = useMemo(() => createStyles(width, height), [width, height]);

    console.log('button disabled', cameraLoading || takePhotoPressed)
    return (
        <div id="pb" className="photobooth" style={styles.root}>
            {step === 0 && <TermsAndConditions onStart={startPhotoBooth} onClose={handleClose}/>}
            {step.in([1, 2, 3, 4]) && (
                <div style={styles.photoRoot}>
                    <audio id="booth_snap_sound" src={CLICK_URL}/>
                    <div className="player-header">
                        {step === 1 && 'Get Ready!'}
                        {step === 2 && 'Select your frame'}
                        {step === 3 && 'Drag and drop your stickers'}
                        {step === 4 && 'Add your caption'}
                    </div>
                    <div id="local-video" className="coverup photovideo-cover photobox" style={styles.videoDiv}>
                        {showFlash && <img src={FlashImg} alt="ShinningImage" style={styles.flesh}/>}
                        <DisplayIf condition={step.in([2, 3])} displayProp='inherit'>
                            <img alt={''}
                                 id="frame-1"
                                 src={selectedFrame}
                                 className="frame-image-inner"
                                 style={styles.selectedFrame}/>
                        </DisplayIf>
                        {showTimer && <div className="booth-timer">{timerCount} {"..."}</div>}
                        <DisplayIf condition={step === 1 && allowed} displayProp='inherit'>
                            <video id="booth_video"
                                   width={width}
                                   height={height}
                                   style={styles.boothVideo}
                                   playsInline
                                   muted
                                   autoPlay/>
                        </DisplayIf>
                        {(step === 1 && !allowed) && <Typography style={{color: 'white'}}>
                            Firstly allow camera usage in your browser
                        </Typography>}
                        <DisplayIf condition={showBoothCanvas} displayProp='block'>
                            <canvas id="booth_canvas" width={width} height={height} style={styles.boothCanvas}/>
                        </DisplayIf>
                        <canvas id="booth_canvas_image" width="1620" height="1620" style={styles.boothCanvasImage}/>
                        <canvas id="booth_canvas_final" width="1620" height="1620" style={styles.boothCanvasFinal}/>
                        <canvas id="booth_final_sticker_canvas"
                                width="1620"
                                height="1620"
                                style={styles.boothFinalStickerCanvas}/>
                        <DisplayIf condition={showStickerContainer} displayProp='block'>
                            <div id="sticker-canvas-container" style={styles.stickerCanvasContainer}>
                                <canvas id="sticker_canvas" width={width} height={height}/>
                            </div>
                        </DisplayIf>
                        <div id="final-image-container">
                            <DisplayIf condition={step === 4} displayProp={'inherit'}>
                                <div id="local-image"
                                     className="frame-image-div frame-image-div-border frame-image-div-bg-color"
                                     style={styles.localImageDiv}>
                                    <img src={finalImageURL} className="frame-image" alt="Frame image"/>
                                </div>
                                <div className="caption-text frame-image-div-border frame-image-div-bg-color"
                                     autofocus={true}
                                     style={styles.captionText}>
                                    {captionText}
                                </div>
                            </DisplayIf>
                        </div>
                        <DisplayIf condition={step.in([2, 3, 4])} displayProp='inherit'>
                            <div onClick={prevStep} style={styles.navigationBtn}>
                                <img src={ButtonBack} alt="<-" style={styles.navImg}/>
                                <br/>
                                Back
                            </div>
                            <div onClick={nextStep} style={{...styles.navigationBtn, ...styles.nextNavBtn}}>
                                <img src={ButtonNext} alt="->" style={styles.navImg}/>
                                <br/>
                                Next
                            </div>
                        </DisplayIf>
                    </div>
                    <DisplayIf condition={step === 1} displayProp='inherit'>
                        <div style={styles.takePhotoDiv}>
                            <DivideSparkImg/>
                            <div>
                                <button className="startBtn"
                                        disabled={cameraLoading || takePhotoPressed}
                                        onClick={snapPhoto}>
                                    Take Photo
                                </button>
                            </div>
                            <DivideSparkImg/>
                        </div>
                    </DisplayIf>
                    <FrameSelect display={step === 2} onFrameSelect={setSelectedFrame}/>
                    <StickerSelect display={step === 3} onSelectSticker={onClickSticker}/>
                    <DisplayIf condition={step === 4} displayProp='inherit'>
                        <div style={styles.caption}>
                            <input className="caption-input"
                                   type="text"
                                   placeholder="Enter your caption here..."
                                   onKeyUp={handleCaptionTextChange}
                                   defaultValue={captionText}/>
                        </div>
                    </DisplayIf>
                </div>
            )}
            {step === 5 && <SubmittedDialog onDownload={() => downloadImage(finalImageURL)}
                                            onClose={handleClose}
                                            onNext={nextStep}/>}
            {step === 6 && <SharePhotoDialog onClose={handleClose}/>}
        </div>
    );
}

export default PhotoBoothPage;
